/* eslint-disable class-methods-use-this */
import SpinProvider from './SpinProvider';
import type { RandomSpin } from './types';

export default class FormalSpinProvider extends SpinProvider {
  getRandomSpin(roundsLeft: number, counterClockwiseChance: number, isBehind: boolean): RandomSpin {
    return this.defaultSpin();
  }
}
